export default "__VITE_ASSET__DivP$TK4__"